export async function apiServiceFetch<T>(
    route: string,
    method: string,
    body?: BodyInit
): Promise<T | undefined> {
    try {
        const requestOptions: RequestInit = {
            method: method,
            headers: {
                "Content-Type": "application/json"
            }
        };

        if (body) {
            requestOptions.body = body;
        }

        const response: Response = await fetch(viteConfiguration.API_URL + route, requestOptions);

        if (!response.ok) {
            console.error("Network response was not ok");
            return undefined;
        }

        return response.json();
    } catch (error) {
        console.error("Error fetching data:", error);
        return undefined;
    }
}
